import QRCode from 'qrcode';
import { useEffect, useState } from 'react';
import type { QrImageProps } from './QrImage.types';

/** Renders a QR code as a data-URL image; nothing leaves the browser. */
export function QrImage({ value, size = 210, alt, className }: QrImageProps): React.JSX.Element | null {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, { width: size * 2, margin: 2, errorCorrectionLevel: 'M', color: { dark: '#080808', light: '#ffffff' } })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setSrc(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (src === null) return null;
  return <img src={src} width={size} height={size} alt={alt} className={className} />;
}
